<script lang="ts">
export interface Props {
    placeholder?: string
    groupClass?: HTMLClass
    narrow?: boolean
    shadow?: string
    border?: string
    background?: HTMLClass
    label?: string
}
</script>
<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import { ref } from 'vue'

import { HTMLClass, MyInputRef } from '@/types/inputs'

import MyInput from '@/components/my-components/form/MyInput.vue'

const props = defineProps<Props>()
const searchQuery = defineModel<string>({ required: true })

const { t } = useI18n()

const inputRef = ref<MyInputRef>()

function focus() {
    inputRef.value?.input.focus()
}

defineExpose({ focus })
</script>

<template>
    <MyInput
        ref="inputRef"
        v-model="searchQuery"
        :group-class="props.groupClass"
        :label="props.label"
        :background="
            props.background ??
            'bg-primary-50 focus:bg-white dark:bg-dark-500 dark:focus:bg-dark-700'
        "
        :placeholder="props.placeholder ?? t('search')"
        class="w-full dark:border-r-0 dark:border-l-0 pt-1.5 pb-1.5"
        :class="props.narrow ? 'h-8' : 'h-10'"
        :shadow="props.shadow"
        :border="props.border"
    >
        <template #icon>
            <mdi:magnify />
        </template>

        <div class="absolute right-2.5 flex items-center z-20">
            <button
                v-if="searchQuery.length > 0"
                class="hidden h-4 w-4 items-center justify-center rounded-full text-[.6rem] group-focus-within:flex dark:bg-dark-500 dark:hover:bg-dark-500/50"
                @click="searchQuery = ''"
            >
                <mdi:close />
            </button>

            <slot name="inputSuffix" />
        </div>
    </MyInput>
</template>
